import store from "@/store";
import {getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";

export interface IAppState {
  appConfig: any;
  sumoStartTime: any;
}

@Module({dynamic: true, store, name: "app"})
class App extends VuexModule implements IAppState {
  appConfig: any = null;
  sumoStartTime: any = null;

  @Mutation
  setAppConfig(appConfig: any) {
    this.appConfig = appConfig;
  }
  @Mutation
  setSumoStartTime(time: any) {
    this.sumoStartTime = time;
  }
}

export const AppModule = getModule(App);
